import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import React from "react";
import { FcGoogle } from "react-icons/fc";
import { toast } from "react-toastify";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

export default function OAuth() {
	const navigate = useNavigate();
	async function onGoogleClick() {
		try {
			const auth = getAuth();
			const provider = new GoogleAuthProvider();
			const result = await signInWithPopup(auth, provider);
			const user = result.user;

			const docRef = doc(db, "users", user.uid);
			const docSnap = await getDoc(docRef);
			if (!docSnap.exists()) {
				await setDoc(docRef, {
					name: user.displayName,
					email: user.email,
					timestamp: serverTimestamp(),
				});
			}
			navigate("/");
		} catch (error) {
			toast.error("Could not authorize with Google");
			console.log(error);
		}
	}
	return (
		<button
			type="button"
			onClick={onGoogleClick}
			className="w-3/4 mx-auto flex items-center justify-center text-white bg-red-600 hover:bg-red-700 p-2 rounded-md uppercase font-medium shadow-md"
		>
			<FcGoogle className="text-2xl bg-white rounded-full mr-2" />
			Continue with Google
		</button>
	);
}
